// Location: src/styles/heroStyles.js
// Date: 20240929
// Author: R Matthews
// Purpose: Styles for hero section components

import { makeStyles, tokens } from '@fluentui/react-components';

export const useHeroStyles = makeStyles({
  hero: {
    display: 'grid',
    margin: tokens.spacingL,
    gridTemplateColumns: '1fr',
    gridTemplateAreas: "'image' 'text'",
    '@media (min-width: 768px)': {
      gridTemplateColumns: '1fr 1fr',
      gridTemplateAreas: "'image text'",
    },
  },
  heroImageContainer: {
    gridArea: 'image',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingM,
    '@media (min-width: 768px)': {
      padding: tokens.spacingL,
    },
  },
  heroImage: {
    width: '100%',
    height: 'auto',
    maxWidth: '44vw',
    borderRadius: tokens.borderRadiusMedium,
  },
  heroTextContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gridArea: 'text',
    margin: tokens.spacingM,
    '@media (min-width: 768px)': {
      textAlign: 'left',
      margin: tokens.spacingL,
    },
  },
});